import React from 'react';
import { NextSeo } from 'next-seo';
import { MainLayout, useLayoutContext } from '@views/layouts';
import MasterLayout from '@views/modules/account-layout';
import Breadcrumb from '@views/modules/order/components/breadcrumb';
import ProductList from '@views/modules/interest-product/dynamic';

import Router from 'next/router';
import { stringify } from 'query-string';

import { INTERNAL_URI, INTERNAL_ROUTES } from '@helpers/route';
import _arrayToString from '@helpers/array-to-string';
import _scrollToTop from '@helpers/scroll-top';

const Content = () => {
  const { me } = useLayoutContext();
  const page = parseInt(_arrayToString(Router.query.page) || '1');

  const handlePageClick = ({ selected }) => {
    const query = {
      page: selected + 1,
    };

    _scrollToTop();

    const queryEncode = stringify(query, { encode: true });
    const uri = `${INTERNAL_ROUTES.INTEREST_PRODUCT}?${queryEncode}`;

    Router.push({ query }, uri);
  };

  const hrefBuilder = (page: number) => {
    const queryEncode = stringify({ page }, { encode: true });
    return `${INTERNAL_ROUTES.INTEREST_PRODUCT}?${queryEncode}`;
  };

  return (
    <ProductList
      page={page}
      customerId={me.get('id')}
      hrefBuilder={hrefBuilder}
      onPageChange={handlePageClick}
    />
  );
};

export const InterestProductPage = (): JSX.Element => {
  return (
    <MainLayout breadcrumb={<Breadcrumb />}>
      <NextSeo title="Sản phẩm quan tâm" nofollow noindex />
      <MasterLayout>
        <Content />
      </MasterLayout>
    </MainLayout>
  );
};

export default InterestProductPage;
